module.exports = __webpack_public_path__ + "static/media/corporate-services-img12.b5358324.jpg";